import { render, staticRenderFns } from "./AdsSlider.vue?vue&type=template&id=04f5c82e&"
import script from "./AdsSlider.vue?vue&type=script&lang=js&"
export * from "./AdsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports